import { render, staticRenderFns } from "./InputSeparatore.vue?vue&type=template&id=aa209902&scoped=true&"
import script from "./InputSeparatore.vue?vue&type=script&lang=js&"
export * from "./InputSeparatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa209902",
  null
  
)

export default component.exports